import React, { Suspense } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { CContainer } from '@coreui/react-pro';

import { guestRoutes } from '../../routes';
import CenterSpinner from '../../components/General/Loadings/CenterSpinner';
import BreadCrumbRouter from '../../components/General/BreadCrumbRouter';
import { GUEST_PATH } from '../../constants';
import { removeSpecialCharacters } from '../../utils';

const IGNORE_BREADCRUMB_ROUTES = ['drm'];

const GuestContent = () => {
     const pathNameArray = [
          GUEST_PATH.CHECKOUT,
          GUEST_PATH.PAYMENT_SUCCESS,
          GUEST_PATH.ACCEPT_YOUR_SEATS.replace(':token/', ''),
          GUEST_PATH.VERIFY_SEAT.replace(':token/', ''),
     ];

     const element = useRoutes(guestRoutes);
     const location = useLocation();
     const checkPath = pathNameArray.some((v) => location.pathname.includes(v));

     const isProductPage = removeSpecialCharacters(location.pathname) === removeSpecialCharacters(GUEST_PATH.SELLING_GROUPS);

     const checkShowBreadCrumb = IGNORE_BREADCRUMB_ROUTES.some((r) => !location.pathname.includes(r)) && !isProductPage;

     return (
          <main>
               <section className={`section-breadcrumb ${checkPath ? ' bg-grey' : ''}`}>
                    {checkShowBreadCrumb && (
                         <CContainer>
                              <BreadCrumbRouter routes={guestRoutes} />
                         </CContainer>
                    )}
               </section>
               <Suspense fallback={<CenterSpinner classNameWrap="page-loading-top" />}>{element}</Suspense>
          </main>
     );
};

export default GuestContent;
